"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCanWriteOrganization = void 0;
const store_1 = require("@app/store");
const util_1 = require("@app/util");
// The organization roles that carry ORGANIZATION_WRITE.
//
// Matched by name rather than by expanding the backend's role → permission table, because that
// table lives on the server and a copy of it here would drift. These two are the roles the
// server grants directly: an organization owner gets `organization_owner`, and a manager of a
// single-workspace organization is handed `organization_write` outright.
//
// Deliberately conservative. A manager of a MULTI-workspace organization who was assigned an org
// role that happens to expand to ORGANIZATION_WRITE (`settings`, `workspaces_positions`, …) is
// not matched here, so the control stays hidden for them even though the server would accept
// them. Hiding a control someone could have used is a smaller failure than offering one that
// answers with a permission error.
const ORGANIZATION_WRITE_ROLES = ['organization_owner', 'organization_write'];
/**
 * Whether the person looking at the page may act on the organization itself — spend its money,
 * claim a discount against its subscription.
 *
 * Separate from what they may SEE: reading is workspace-level and every manager has it, acting
 * on the organization is organization-level and most of them do not.
 *
 * Not to be confused with `useIsOrgOwner` (`tiers-hooks.ts`), which is ANDed with `isDsPro` and
 * so is false for every trial organization.
 */
const useCanWriteOrganization = () => {
    const organizationId = (0, store_1.useRootSelector)((state) => state.organizationId);
    const organizations = (0, store_1.useRootSelector)((state) => state.me.acl?.organizations);
    if (!(0, util_1.isValue)(organizationId) || !(0, util_1.isValue)(organizations))
        return false;
    const roles = organizations[organizationId] ?? [];
    return ORGANIZATION_WRITE_ROLES.some((role) => roles.includes(role));
};
exports.useCanWriteOrganization = useCanWriteOrganization;
exports.default = exports.useCanWriteOrganization;
